import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const experienceDetailService = {
  fetchExperienceDetailByCandidateID: (id) => {
    return axiosInstance.get(
      `/itl_experiencedetails?$select=itl_experiencedetailid,_itl_candidateid_value,itl_designation,itl_name,itl_periodfrom,itl_periodto,itl_reasonforleaving,itl_address,itl_salarydrawn&$filter=_itl_candidateid_value eq ${id}`,
      {
        headers: headers,
      }
    );
  },

  addExperienceDetail: (obj) => {
    return axiosInstance.post(`/itl_experiencedetails`, obj, {
      headers: headers,
    });
  },

  updateExperienceDetail: (id, obj) => {
    return axiosInstance.patch(`/itl_experiencedetails(${id})`, obj, {
      headers: headers,
    });
  },

  deleteExperienceDetail: (id) => {
    return axiosInstance.delete(`/itl_experiencedetails(${id})`, {
      headers: headers,
    });
  },
};

export default experienceDetailService;
